import script from "./LoginWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginWidget.vue?vue&type=script&setup=true&lang=js"

import "./LoginWidget.vue?vue&type=style&index=0&id=48155d5d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48155d5d"]])

export default __exports__